import React from 'react'
import { HomeRails } from '../home-rails'
import SkillBiteCard from '../../../skill-bites/components/cards/skill-bites-card'
import { useFormFactor } from '../../../../hooks'
import { Typography } from '@mui/material'
import { Link, useNavigate } from 'react-router-dom'
import { useTrackHomeEnterpriseEvent } from '../../hooks/useTrackHomeEnterpriseEvent'
import { routes } from '../../../../router/routes'
import { useHomeEnterpriseContext } from '../../context/home-enterprise-page-context'
import { useDisplayAddToPlaylist } from '../../../../hooks/useDisplayAddToPlaylist'

export const SkillBitesRails = ({ skillBitesSection }) => {
  const { items } = skillBitesSection
  const { isMobile } = useFormFactor()
  const navigate = useNavigate()
  const { trackSkillBiteClickEvent } = useTrackHomeEnterpriseEvent()
  const { showAddToPlaylist } = useHomeEnterpriseContext()
  const displayAddToPlaylist = useDisplayAddToPlaylist()

  const handleCardClick = (skillBite) => {
    navigate(`/skill-bites/${skillBite.id}?from=home-page`)
    trackSkillBiteClickEvent(skillBite.id, {
      name: skillBite.name
    })
  }

  const handleAddToPlaylist = (skillBite) => {
    if (showAddToPlaylist) {
      showAddToPlaylist({
        skillBiteId: skillBite.id,
        title: skillBite.name,
        image: skillBite.image,
        sessionCount: skillBite.sessionCount
      })
    }
  }

  return (
    <HomeRails
      title='Build your skills in just 15 minutes per session'
      items={items}
      dataTest='home-skill-bites-rails'
      exploreMoreCta={(
        <Typography variant={!isMobile ? 'caption' : undefined}>
          See all <Link to={routes['skill-bites'].path}>Skill Bites</Link>
        </Typography>
      )}
      renderItem={(item, itemIndex) => {
        return (
          <SkillBiteCard
            isLoading={false}
            variant='generic'
            skillBite={item}
            hideSubscribeButton
            onClick={(skillBite) => handleCardClick(skillBite)}
            onAddToPlaylist={displayAddToPlaylist ? handleAddToPlaylist : undefined}
            addToPlaylistButtonSize='s'
            key={itemIndex}
          />
        )
      }}
    />
  )
}
